/* eslint camelcase: ["error", {"properties": "never", ignoreDestructuring: true}] */

export const parseToSaveProduct = (product) => {
  const {
    manufacturer,
    group,
    category,
    current_quantity,
    tax,
    ...rest
  } = product

  const manufaturerId = manufacturer?.id
  const groupId = group?.id
  const categoryId = category?.id

  const parse = {
    ...rest,
    manufacturer_id: manufaturerId,
    product_group_id: groupId,
    product_category_id: categoryId,
  }

  return parse
}
